import React from 'react';

import cn from 'classnames';

import { Icon } from '@shared/ui';

import cls from './DraggableEl.module.css';

interface IDraggableElProps extends React.HTMLAttributes<HTMLSpanElement> {
    isProceed?: boolean;
}
export const DraggableEl = ({ className, isProceed, ...rest }: IDraggableElProps) => (
    <span className={cn(cls.DraggableEl, className)} {...rest}>
        <Icon iconName="draggableHandle" fill={isProceed ? '#81899880' : '#818998'} />
    </span>
);
